import { ASSIGN_STUDIO_CONFIG } from '../gql/mutations/studio'
import { AssignStudioConfigValuesType } from '../types/upgrade.types'
import { gqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'

const assignConfig = async (variables: {
  configInput: AssignStudioConfigValuesType
}): Promise<{ assignStudioConfiguration: { ok: boolean } }> => {
  return gqlFetcher(ASSIGN_STUDIO_CONFIG, variables.configInput)
}

export const callAssignConfig = async (
  configInput: AssignStudioConfigValuesType
): Promise<void> => {
  try {
    const res = await assignConfig({
      configInput
    })
  } catch (e) {
    console.error(e.message)
  }
}
